(function () {
  function parseMoneyToNumber(str) {
    if (!str) return null;
    const match = String(str).match(/[\d.,]+/);
    if (!match) return null;
    const n = match[0].replace(/,/g, "");
    const val = Number(n);
    return Number.isFinite(val) ? val : null;
  }

  function formatSaveAmount(amount, currencySymbol = "$") {
    if (!Number.isFinite(amount)) return "";
    const rounded = Math.round(amount * 100) / 100;
    const isWhole = Math.abs(rounded - Math.round(rounded)) < 0.00001;
    return isWhole
      ? `${currencySymbol}${Math.round(rounded)}`
      : `${currencySymbol}${rounded.toFixed(2)}`;
  }

  function initSubscriptionsDropdown(fieldset) {
    if (!fieldset || fieldset.dataset.subsDropdownInit === "true") return;

    const planList = fieldset.querySelector(".shopify_subscriptions_app_block_label_children");
    if (!planList) return;

    const oneTimeRadio = fieldset.querySelector(
      'input[type="radio"][data-radio-type="one_time_purchase"]'
    );

    const oneTimePriceStr =
      oneTimeRadio?.getAttribute("data-variant-price") ||
      oneTimeRadio?.getAttribute("aria-label") ||
      "";
    const oneTimePrice = parseMoneyToNumber(oneTimePriceStr);
    const currencySymbol = (oneTimePriceStr.match(/[$£€]/)?.[0]) || "$";

    const subscribeBlock = planList.closest(".shopify_subscriptions_app_block_label");
    const subscribeWrapper = subscribeBlock?.querySelector(".shopify_subscriptions_purchase_option_wrapper");
    const subscribeTitleLabel = subscribeWrapper?.querySelector("label");
    const subscribePriceEl = subscribeWrapper?.querySelector(".shopify_subscriptions_in_widget_price");

    // Prevent duplicate injection
    if (subscribeWrapper?.querySelector(".subs-select-wrapper")) {
      fieldset.dataset.subsDropdownInit = "true";
      return;
    }

    const getPlanInputs = () =>
      Array.from(
        fieldset.querySelectorAll(
          'input[type="radio"][data-radio-type="selling_plan"][data-selling-plan-id]'
        )
      );

    const planInputsInitial = getPlanInputs();
    if (!planInputsInitial.length) return;

    // --- Build select ---
    const select = document.createElement("select");
    select.className = "subs-frequency-select";
    select.setAttribute("aria-label", "Delivery frequency");

    planInputsInitial.forEach((input) => {
      const sellingPlanId = input.getAttribute("data-selling-plan-id");
      const labelTextRaw = input.closest("label")?.textContent?.trim() || "Subscription option";

      const planPriceStr = input.getAttribute("data-variant-price") || "";
      const planPrice = parseMoneyToNumber(planPriceStr);

      let savePart = "";
      if (Number.isFinite(oneTimePrice) && Number.isFinite(planPrice)) {
        const save = oneTimePrice - planPrice;
        if (save > 0) savePart = ` — Save ${formatSaveAmount(save, currencySymbol)}`;
      }

      const cleanedLabel = labelTextRaw.replace(/,\s*\d+%.*$/i, "");
      const opt = document.createElement("option");
      opt.value = sellingPlanId;
      opt.textContent = `${cleanedLabel}${savePart}`;
      select.appendChild(opt);
    });

    // Set initial select value from currently checked selling plan, else first
    const checkedPlan = fieldset.querySelector(
      'input[type="radio"][data-radio-type="selling_plan"]:checked'
    );
    select.value =
      checkedPlan?.getAttribute("data-selling-plan-id") ||
      planInputsInitial[0].getAttribute("data-selling-plan-id");

    // --- Wrapper with chevron (CSS) ---
    const selectWrapper = document.createElement("div");
    selectWrapper.className = "subs-select-wrapper";
    selectWrapper.appendChild(select);

    planList.parentElement.insertBefore(selectWrapper, planList);
    // --- Move policy text inside Subscribe & Save (under the dropdown) ---
const policyEl = fieldset.querySelector("p.shopify_subscriptions_app_policy");
if (policyEl && !policyEl.classList.contains("subs-policy-moved")) {
  policyEl.classList.add("subs-policy-moved");
  // Place directly under the dropdown wrapper
  selectWrapper.insertAdjacentElement("afterend", policyEl);
}
    planList.classList.add("subs-frequency-list--hidden");

    // --- Faux radio + title badge + price row layout ---
    if (subscribeWrapper) {
      subscribeWrapper.classList.add("subs-subscribe-header");

      if (!subscribeWrapper.querySelector(".subs-faux-radio")) {
        const fauxRadio = document.createElement("span");
        fauxRadio.className = "subs-faux-radio";
        fauxRadio.setAttribute("aria-hidden", "true");
        subscribeWrapper.insertBefore(fauxRadio, subscribeWrapper.firstChild);
      }

      if (subscribeTitleLabel && !subscribeTitleLabel.dataset.subsStyled) {
        subscribeTitleLabel.dataset.subsStyled = "true";
        subscribeTitleLabel.classList.add("subs-subscribe-title");
        subscribeTitleLabel.innerHTML =
          'Subscribe & <span class="subs-save-badge">SAVE 10%</span>';
      }

      let priceRow = subscribeWrapper.querySelector(".subs-price-row");
      if (!priceRow) {
        priceRow = document.createElement("div");
        priceRow.className = "subs-price-row";
        subscribeWrapper.appendChild(priceRow);
      }

      if (subscribePriceEl && !priceRow.contains(subscribePriceEl)) {
        priceRow.appendChild(subscribePriceEl);
      }
    }

    function ensureSaveEl() {
      if (!subscribeWrapper) return null;
      let saveEl = subscribeWrapper.querySelector(".subs-save-amount");
      if (!saveEl) {
        saveEl = document.createElement("div");
        saveEl.className = "subs-save-amount";
      }
      const priceRow = subscribeWrapper.querySelector(".subs-price-row");
      if (priceRow && !priceRow.contains(saveEl)) {
        priceRow.insertBefore(saveEl, priceRow.firstChild);
      }
      return saveEl;
    }

    function updateSaveAmountDisplay() {
      const planInputs = getPlanInputs();
      if (!planInputs.length) return;

      const currentPlanId = select.value;
      const currentInput =
        planInputs.find((i) => i.getAttribute("data-selling-plan-id") === currentPlanId) ||
        planInputs[0];

      const planPriceStr = currentInput.getAttribute("data-variant-price") || "";
      const planPrice = parseMoneyToNumber(planPriceStr);

      let saveText = "";
      if (Number.isFinite(oneTimePrice) && Number.isFinite(planPrice)) {
        const save = oneTimePrice - planPrice;
        if (save > 0) saveText = `Save ${formatSaveAmount(save, currencySymbol)}`;
      }

      const saveEl = ensureSaveEl();
      if (saveEl) {
        saveEl.textContent = saveText;
        saveEl.style.display = saveText ? "" : "none";
      }
    }

    function syncSubscribeSelectedState() {
  const checkedSellingPlan = fieldset.querySelector(
    'input[type="radio"][data-radio-type="selling_plan"]:checked'
  );

  const isSubSelected = !!checkedSellingPlan;

  // Toggle selected styling on the Subscribe & Save block (fills faux radio)
  if (subscribeBlock) {
    subscribeBlock.classList.toggle("subs-is-selected", isSubSelected);
  }

  // Show / hide the policy text based on subscription selection
  const policyEl = fieldset.querySelector("p.shopify_subscriptions_app_policy");
  if (policyEl) {
    policyEl.style.display = isSubSelected ? "" : "none";
  }
}


    function selectSellingPlanById(sellingPlanId) {
      const target = fieldset.querySelector(
        `input[type="radio"][data-radio-type="selling_plan"][data-selling-plan-id="${CSS.escape(
          sellingPlanId
        )}"]`
      );
      if (!target) return;

      // Set checked + dispatch change ONLY on the selling plan radio.
      // Do NOT dispatch events on one-time radio (it can clear selling_plan).
      target.checked = true;
      target.dispatchEvent(new Event("change", { bubbles: true }));

      // Shopify sometimes re-renders after change; re-sync after paint
      syncSubscribeSelectedState();
      updateSaveAmountDisplay();
      requestAnimationFrame(() => {
        syncSubscribeSelectedState();
        updateSaveAmountDisplay();
      });
    }

    select.addEventListener("change", (e) => {
      selectSellingPlanById(e.target.value);
    });

    if (subscribeWrapper) {
      subscribeWrapper.addEventListener("click", (evt) => {
        if (evt.target && (evt.target.tagName === "SELECT" || evt.target.closest(".subs-select-wrapper"))) return;
        selectSellingPlanById(select.value);
      });
    }

    // Keep dropdown in sync if Shopify toggles radios
    fieldset.addEventListener("change", () => {
      const checked = fieldset.querySelector(
        'input[type="radio"][data-radio-type="selling_plan"]:checked'
      );
      if (checked) {
        const id = checked.getAttribute("data-selling-plan-id");
        if (id) select.value = id;
      }
      syncSubscribeSelectedState();
      updateSaveAmountDisplay();
    });

    // Initial sync
    syncSubscribeSelectedState();
    updateSaveAmountDisplay();

    fieldset.dataset.subsDropdownInit = "true";
  }

  function boot(root = document) {
    root.querySelectorAll("fieldset.shopify_subscriptions_fieldset").forEach(initSubscriptionsDropdown);
  }

  document.addEventListener("DOMContentLoaded", () => boot());
  document.addEventListener("shopify:section:load", (e) => boot(e.target));

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.("fieldset.shopify_subscriptions_fieldset")) initSubscriptionsDropdown(node);
        node.querySelectorAll?.("fieldset.shopify_subscriptions_fieldset").forEach(initSubscriptionsDropdown);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
